import 'babel-polyfill';
import 'react-app-polyfill/ie9'
import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'

import {store, persistor} from './utils/configureStore';

import "./polyfill";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './utils/ErrorBoundary';
import * as Sentry from '@sentry/browser';

const NODE_ENV = process.env.NODE_ENV;
const SENTRY_DSN =process.env.SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: NODE_ENV});

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </PersistGate>
    </Provider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
